/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AuthParams } from '../models/AuthParams';

export class ConnectAwsOrganizationRequest {
  'authParams': AuthParams;
  /**
  * The organization OUID.
  */
  'organizationOUId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "authParams",
      "baseName": "authParams",
      "type": "AuthParams",
      "format": ""
    },
    {
      "name": "organizationOUId",
      "baseName": "organizationOUId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ConnectAwsOrganizationRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

